import { useEffect, useState } from 'react';

interface AnimatedCounterProps {
  value: number;
  className?: string;
}

const AnimatedCounter = ({ value, className = '' }: AnimatedCounterProps) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 300);
    return () => clearTimeout(timer);
  }, [value]);

  return (
    <h3
      className={`
        text-2xl 
        text-foreground 
        font-bold 
        transition-transform duration-300
        lg:text-4xl 
        ${animate ? 'scale-[1.2] opacity-70' : 'scale-100 opacity-100'}
        ${className}
      `}
    >
      {value.toLocaleString()}
    </h3>
  );
};

export { AnimatedCounter };
